import { Typography } from 'core/Typography';
import React from 'react';
import SectionWrapper from 'shared/SectionWrapper';

function CardText({ text, name, post }: { text?: string; name?: string; post?: string }) {
    return (
        // eslint-disable-next-line max-len
        <div className="p-[16px] xl-desktop:p-[32px] justify-between gap-[20px] flex flex-col bg-bg-grey rounded-[24px] ">
            <Typography
                // eslint-disable-next-line max-len
                className="relative before:content-['«'] before:mr-1 mobile:before:-top-0.5 before:font-bold mobile:before:text-[22px]!
                mobile:before:leading-[120%]! before:text-[#11AFCC] before:text-[14x] after:content-['»']
                after:ml-1 after:font-bold after:text-[#11AFCC] after:text-[14px] mobile:after:text-[22px]!
                mobile:after:leading-[120%]!"
            >
                {text}
            </Typography>
            <div className="flex flex-col">
                <Typography
                    variant="span"
                    // eslint-disable-next-line max-len
                    className="font-semibold mobile:text-[20px] text-[12px] leading-[140%]! mobile:leading-[150%]!"
                >
                    {name}
                </Typography>
                <Typography
                    variant="span"
                    // eslint-disable-next-line max-len
                    className="font-normal text-[#587289]! mobile:text-[18px] text-[10px] leading-[140%]! mobile:leading-[150%]!"
                >
                    {post}
                </Typography>
            </div>
        </div>
    );
}

function Process() {
    return (
        <SectionWrapper>
            <div className="flex flex-col gap-[40px] lg-tablet:gap-[60px]">
                <div className="flex flex-col gap-[12px] mobile:gap-[16px] lg-tablet:gap-[24px]">
                    <Typography variant="h2">Процесс</Typography>
                    <Typography variant={'h3'}>Исследование и кастдев</Typography>
                    <Typography className="lg-tablet:max-w-8/12">
                        Команда продукта провела серию глубинных интервью с 20 руководителями
                        и HR-директорами крупных компаний. Результаты подтвердили гипотезу:
                        системного подхода к оценке софт-скилов на рынке практически нет.
                        Большинство решений строится на глубоком профессиональном опыте и суждении
                        рекрутера. Компании подтвердили, что без технологической поддержки эту
                        экспертизу сложно оцифровать — объективно сравнить нескольких сильных
                        кандидатов между собой или быстро обосновать выбор для нанимающего
                        менеджера.
                    </Typography>
                </div>

                <div
                    className={
                        // eslint-disable-next-line max-len
                        'grid grid-cols-1 lg-tablet:grid-cols-3 gap-[24px] xl-desktop:gap-y-[24px] xl-desktop:gap-x-[40px]'
                    }
                >
                    <CardText
                        name={'Тимур Скачков'}
                        post={'HR-директор, IT-компания'}
                        text={
                            // eslint-disable-next-line max-len
                            'Самая сложная часть — не найти кандидата, а «продать» его нанимающему менеджеру. Руководители отделов мыслят цифрами, а у меня на руках — только мои заметки и профессиональный опыт. Мне нужен «мост» между моей экспертизой и их языком данных. Я должен показать, почему этот кандидат сильный, а не просто сказать, что я так «чувствую'
                        }
                    />
                    <CardText
                        name={'Ринат Альферов'}
                        post={'Руководитель отдела подбора, банк'}
                        text={
                            // eslint-disable-next-line max-len
                            'Мои рекрутеры — опытные специалисты, а не роботы. Но когда у нас в финале три сильных кандидата, начинается «магия». Один «берет» харизмой, другой — системностью. Нам не хватает данных, чтобы положить их «на весы» и объективно сравнить именно те софт-скилы, которые нужны для этой роли. В итоге мы тратим часы на споры, которые все равно основаны на «экспертном мнении», а не на данных'
                        }
                    />
                    <CardText
                        name={'Алевтина Васильева'}
                        post={'HR Business Partner, Ритейл'}
                        text={
                            // eslint-disable-next-line max-len
                            'После пятого интервью в день все кандидаты сливаются в одно пятно. Я знаю, что в этих часовых диалогах были маркеры и «красные флаги», но я физически не могу их все удержать в голове и перенести в CRM. Мне нужен не контролер, который скажет, что я неправа, а помощник, который проанализирует рутину и подсветит мне ключевые моменты из беседы, чтобы я могла принять взвешенное решение'
                        }
                    />
                </div>
            </div>
        </SectionWrapper>
    );
}

export default Process;
